import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import heartpop from '../Common/Assets/Images/dummyProfile.png';
import heartbg from '../Common/Assets/Images/bg.png';
import { Modal, Button } from 'react-bootstrap';
import HeartPopup2 from './HeartPopup2';

function HeartPopup({ matcherData, csid, showModal = false, onClose }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(showModal);
  const [showSecondModal, setShowSecondModal] = useState(false);

  useEffect(() => {
    setIsOpen(showModal);
  }, [showModal]);

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  const handleNotRelevant = () => {
    setIsOpen(false);
    setShowSecondModal(true);
  };

  return (
    <>
      <Modal
        show={isOpen}
        onHide={handleClose}
        className="heart-popup-3"
        contentClassName="heart-popup-modal-content"
        aria-labelledby="exampleModalLabel"
      >
        <Modal.Body>
          <button
            type="button"
            className="btn-close remove-btn-close-cross"
            onClick={handleClose}
            aria-label="Close"
          >
            <i className="bi bi-x-lg"></i>
          </button>
          <div className="main-img-heartpopup">
            <img
              src={matcherData && matcherData.matcherImage ? matcherData.matcherImage : heartpop}
              className="d-block main-home-profile-img-slide"
              alt="img-1"
            />
          </div>
          <h2 className="heart-popup-heading-text">{t('title-web-page-popup')}</h2>
          <p className="heart-popup-pehra-text">
            {t('title-web-page-description').replace(
              '<mxxxx>',
              matcherData && matcherData.matcherName ? matcherData.matcherName : ' ',
            )}
          </p>
          <div className="heart-popup-button-box">
            <Button onClick={handleNotRelevant}>{t('title-web-page-btn1')}</Button>
            <Button className="button-blank-box exit-popup" onClick={handleClose}>
              {t('title-web-page-btn2')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <HeartPopup2
        csid={csid}
        showModal={showSecondModal}
        onClose={() => setShowSecondModal(false)}
      />
    </>
  );
}

export default HeartPopup;
